export default __webpack_public_path__ + "static/media/Caja_Alta_Eneable.348fc3b3.svg";